/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React, { useMemo, useState } from "react";
import { TViewComponent } from "../../../view/IView";
import { ReferenceGuide } from "./ReferenceGuide";
import { Layout } from "../../../ui/components/Layout/Layout";
import { ReferenceGuideMain } from "./components";
import { ReferenceGuideSidebar } from "./components/ReferenceGuideSidebar";
import { ReferenceGuideRightbar } from "./components/ReferenceGuideRightbar";
import { useCommand, useSimpleEvent } from "../../../ui/hooks";
import { TReferenceData } from "./ReferenceGuideTypes";

export const ReferenceGuideComponent: TViewComponent<ReferenceGuide> = ({ view }) => {
	const layoutState = useMemo(() => view.getLayout(), []);

	const [ nav, setNav ] = useState(view.getNav());

	const [ selected, setSelected ] = useState(view.getSelected() || null);
	const [ data, setData ] = useState<TReferenceData>(view.getContent());
	const [ rightNav, setRightNav ] = useState<TReferenceData>(view.getContent());

	const [ selectNavItem ] = useCommand("referenceGuide.open");

	useSimpleEvent(
		view.onSelectedChange,
		() => {
			setSelected(view.getSelected());
			setData(view.getContent());
			setRightNav(view.getContent());
		},
		[]
	);

	const updateNav = () => {
		setNav(view.getNav());
	};

	if (!data) {
		return <></>;
	}

	const renderComponent = (componentName: string) => {
		switch (componentName) {
			case "sidebar":
				return (
					<ReferenceGuideSidebar
						className="edt-base"
						setSelected={selectNavItem}
						selected={selected}
						view={view}
						updateNav={updateNav}
						nav={nav}
					/>
				);
			case "main":
				return <ReferenceGuideMain className="edt-base" view={view} data={data} />;
			case "rightbar":
				return <ReferenceGuideRightbar className="edt-base" nav={rightNav} />;
			default:
				return <p>Error: Undefined panel {componentName}.</p>;
		}
	};

	return <Layout state={layoutState} renderComponent={renderComponent} />;
};
